import { extensions } from '../../extensions/Extensions.mjs';
import { GraphicsContextSystem } from './shared/GraphicsContextSystem.mjs';
import { GraphicsPipe } from './shared/GraphicsPipe.mjs';

"use strict";
extensions.add(GraphicsPipe);
extensions.add(GraphicsContextSystem);
//# sourceMappingURL=init.mjs.map
